import styled from 'styled-components'
import { StyledChart } from '../../styles'

export const StyledOnTopicChart = styled(StyledChart)`
  .highcharts-color-0 {
    fill: ${({ theme }) => theme.colors.dataVisualisation.barGraph};
  }
`
